<div class="screen">

    <div class="uk-text-center" *ngIf="isTelecom">
        <select class="lobSelector custom-select" [(ngModel)]="lobSelected"  (ngModelChange)="changeLOB(lobSelected)">
            <option selected hidden ngValue="">Select LOB</option>
            <option *ngFor = "let lob of lobs" [ngValue]="lob[1]">{{lob[0]}}</option>
        </select>
    </div>
    <br>

    <div class="componentPane" *ngIf="lobSelected != ''">
            
        <h3 class="page-subheading uk-text-center">Disposition Group</h3>
        <app-response-text
            class="uk-text-center"
            [lambdaMessage]="lambdaMessage2"
            [lambdaError]="lambdaError2"
            [messageTime]="8"
            >
        </app-response-text>
        <app-group-editor
            [LOB]="lobSelected"
            [groupData]="dispositionGroups"
            [queueData]="data"
            [queueGroupId]="'dispositionGroupId'"
            (onGroupChange)="updateGroup($event)"
            (onQueueChange)="updateItem($event)"
            (onButtonClick)="lambdaMessage2=''; lambdaError2=false;"
            >
        </app-group-editor>

    </div> 
    <div class="mainTable" *ngIf="lobSelected != ''">
        <div class="tablePane">
            <h3 class="page-subheading" >Queue</h3>

            <app-response-text
            class="uk-text-center"
            [lambdaMessage]="lambdaMessage"
            [lambdaError]="lambdaError"
            [messageTime]="8"
            ></app-response-text>
            <div class="table-container">
                <app-mat-data-grid
                    [dataSource]="tableContent"
                    [displayedColumns]="['queueName', 'language', 'dispositionGroup', 'queueGroup']"
                    [columnNames]="['Queue Name', 'Language', 'Disposition Group', 'Queue Group']"
                    [pageSizeOptions]="[5, 10, 25, 50]"
                    [buttonConfig]="{
                        delete: { show: false },
                        edit: { show: false}
                    }"
                    [objectBluePrint]="bluePrint"
                >
                </app-mat-data-grid>

            </div>
        </div>   
    </div>
</div>
